exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-grid[data-v-31c18734] {\n  display: grid;\n  grid-gap: 16px;\n  grid-template-columns: repeat(1, 1fr);\n}", ""]);

// exports
